<template>
  <component
    :is="getQuotaComponent(props.invitationQuota.kind)"
    :invitation-quota="props.invitationQuota"
    :loading="props.loading"
    :is-limit-reached="isLimitReached"
  >
    <RouterView :invitation-quota="props.invitationQuota" :loading="props.loading" :is-limit-reached="isLimitReached" />
  </component>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'

import { InvitationQuotaTypeEnum, type InvitationQuotaQuery } from '@/gql/myomr'

import { CodeQuota, InternalQuotaDataProvider } from '.'

const props = defineProps<{
  invitationQuota: InvitationQuotaQuery['invitationQuota']
  loading: boolean
}>()

const quotaComponents: Partial<Record<InvitationQuotaTypeEnum, Component>> = {
  [InvitationQuotaTypeEnum.CodeQuota]: CodeQuota,
  [InvitationQuotaTypeEnum.CrewQuota]: InternalQuotaDataProvider,
  [InvitationQuotaTypeEnum.ExhibitorQuota]: InternalQuotaDataProvider,
  [InvitationQuotaTypeEnum.GuestQuota]: InternalQuotaDataProvider,
  [InvitationQuotaTypeEnum.PressQuota]: InternalQuotaDataProvider,
}

function getQuotaComponent(quotaType: InvitationQuotaTypeEnum) {
  return quotaComponents[quotaType]
}

const isLimitReached = computed(() => (props.invitationQuota.usableTicketsCount || 0) >= (props.invitationQuota.maxUsable || 0))
</script>
